/** @jsxImportSource @emotion/react */

import React, { Fragment } from 'react';

import LeaguePosition from '../LeaguePosition';
import MatchDetails from '../MatchDetails';
import Text from '../Text';
import useStyles from './styles';

export const teamStatsRef = React.createRef();

const TeamStatus = ({
  lastresults,
  standingspositions,
  title,
  teamDetails,
}) => {
  const { nextfixtures } = teamDetails;
  const styles = useStyles(); 

  // variables for dynamic margin-bottom for Team Stats Section  
  let mbNext = 12, mbLast = 12, mbPos = 40;
  (() => {
    if(nextfixtures && !lastresults && !standingspositions) mbNext = 40;
    else if(!nextfixtures && lastresults && !standingspositions) mbLast = 40;
    else if(nextfixtures && lastresults && !standingspositions) mbLast = 40;
  })();

  return (
    <Fragment>
      <div css={styles.middle}>
        <div css={styles.leftContent}>
          <div css={styles.top} ref={teamStatsRef}>
            <Text css={styles.title}>Fixtures, results and standings</Text>
          </div>

          {nextfixtures && (
            <div css={styles.nextfixturesWrapper(mbNext)}>
              <MatchDetails isClubInfo={true} {...nextfixtures} />
            </div>
          )}
          {lastresults && (
            <div css={styles.lastresultsWrapper(mbLast)}>
              <MatchDetails isClubInfo={true} {...lastresults} />
            </div>
          )}
          {standingspositions && (
            <div css={styles.standingspositionssWrapper(mbPos)}>
              <LeaguePosition isClubInfo={true} {...standingspositions} />
            </div>
          )}

        </div>
      </div>
      <div css={styles.imgWrapper}>
        <div css={styles.imgContent}></div>
      </div>
    </Fragment>
  );
};

export default TeamStatus;